/** 通用控制器 */
import cookie from 'js-cookie'

export default {
    methods: {
        getParentID () {
            return (
                cookie.get('mathparentid') || cookie.get('mbparentid') || null
            )
        }
    }
}
